<div class="row">
  <div class="col-md-6">
    <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
      <div class="row">
        <div class="col-md-5 cstmcol">
          <div class="actvts" style="background: #544795">
            Activities
            <span style="color: #ffdaa1"
              >({{
                wrkData && wrkData.no_of_wrk_assigned
                  ? wrkData.no_of_wrk_assigned
                  : 0
              }})</span
            >
          </div>
        </div>
        <div class="col-md-7 lftpdngnone" style="text-align: right">
          @for (t of tabsActdata; track t) {
          <div
            class="tabs_data"
            (click)="slectdActTab(t)"
            [ngClass]="t.tab_id == slctdActdt ? 'slct_dt' : 'dflt_dt'"
          >
            {{ t.tab_nm }}
          </div>
          }
        </div>
      </div>
      <div class="row rwpdng">
        <div class="col-md-4">
          <div class="cnt">
            {{ empdtls && empdtls.length ? empdtls[0].in_prgrs : 0 }}
            <!-- <a nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft" [nzOverlayClassName]="'cstmdrpdwn'" style="padding-left: 10px;">
                            <span nz-icon nzType="info-circle" nzTheme="outline" style="font-size: 20px;
        color: #d76f52;    vertical-align: baseline;"></span>
          </a> -->
          </div>
          In Progress
        </div>

        <div class="col-md-4">
          <div class="cnt">
            {{ empdtls && empdtls.length ? empdtls[0].cmpleted : 0 }}

            <!-- <a nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft" [nzOverlayClassName]="'cstmdrpdwn'" style="padding-left: 10px;">
                            <span nz-icon nzType="info-circle" nzTheme="outline" style="font-size: 20px;
        color: #d76f52;    vertical-align: baseline;"></span>
        </a> -->
          </div>
          <div class="crd_title">
            <span class="cstmfnt" style="color: #3f51b5"> Completed</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
      <div class="row">
        <div class="col-md-5 cstmcol">
          <div class="actvts" style="background: #544795">
            Attendance <span style="color: #ffdaa1"></span>
          </div>
        </div>
        <div class="col-md-7 lftpdngnone" style="text-align: right">
          @for (t of tabsAtnddata; track t) {
          <div
            class="tabs_data"
            (click)="slectdAtnTab(t)"
            [ngClass]="t.tab_id == slctdAtnd ? 'slct_dt' : 'dflt_dt'"
          >
            {{ t.tab_nm }}
          </div>
          }
        </div>
      </div>
      <div class="row rwpdng">
        <div class="col-md-4">
          <div class="cnt">
            {{ empdtlsr && empdtlsr.length ? empdtlsr[0].total_days : 0 }}
            <!-- <a nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft" [nzOverlayClassName]="'cstmdrpdwn'" style="padding-left: 10px;">
                            <span nz-icon nzType="info-circle" nzTheme="outline" style="font-size: 20px;
        color: #d76f52;    vertical-align: baseline;"></span>
        </a> -->
          </div>
          <div class="crd_title">
            <span class="cstmfnt" style="color: #f19000"> Total Days</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="cnt">
            {{ empdtlsr && empdtlsr.length ? empdtlsr[0].present : 0 }}
            <!-- <a nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft" [nzOverlayClassName]="'cstmdrpdwn'" style="padding-left: 10px;">
                            <span nz-icon nzType="info-circle" nzTheme="outline" style="font-size: 20px;
        color: #d76f52;    vertical-align: baseline;"></span>
      </a> -->
          </div>
          <div class="crd_title">
            <span class="cstmfnt" style="color: #4caf50"> Present</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="cnt">
            {{ empdtlsr && empdtlsr.length ? empdtlsr[0].absent : 0 }}
            <!-- <a nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft" [nzOverlayClassName]="'cstmdrpdwn'" style="padding-left: 10px;">
                            <span nz-icon nzType="info-circle" nzTheme="outline" style="font-size: 20px;
        color: #d76f52;    vertical-align: baseline;"></span>
    </a> -->
          </div>
          <div class="crd_title">
            <span class="cstmfnt" style="color: #3f51b5"> Absent</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4"></div>

  <div class="col-md-6">
    <div class="col-lg-12 col-md-12">
      <!-- <nz-date-picker   [nzFormat]="dateFormat"    (ngModelChange) = "getfrmdt(frm_dt)" [(ngModel)]="frm_dt" ></nz-date-picker> -->

      <nz-range-picker
        [(ngModel)]="dateFormat"
        nzFormat="dd MM yyyy"
        (ngModelChange)="onChange($event)"
      ></nz-range-picker>
    </div>

    <!-- <div class="col-lg-4 col-md-6">
    <span>To Date:</span>
    <nz-date-picker [nzFormat]="dateFormat"   (ngModelChange) = "getfrmdts(to_dt)"   [(ngModel)]="to_dt" ></nz-date-picker>
  </div> -->
  </div>
  <div class="col-lg-2 col-md-2">
    <!-- Optional content like buttons, empty space -->
  </div>
</div>

<div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
  <div class="col-lg-12 col-md-12 mgnb-2 p-8">
    <app-data-grid
      id="gridContainer"
      class="p-8"
      style="width: 100%"
      [dataSource]="grddtls"
      [legacyColumns]="columnEmplyDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="false"
      [allowExport]="true"
      [pageSize]="10"
      [allowedPageSizes]="[5, 10, 25, 50]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <!-- -->
      <!-- -->
      <!-- -->

      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [width]="100"
        caption="View"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="gotoProfile(data, 'employ')">
            <i nz-icon nzType="eye" nzTheme="outline"></i>
            <p>View Profile</p>
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
</div>

<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="1000"
  [nzVisible]="sidenav"
  [nzTitle]="drwerTitle"
  (nzOnClose)="closeSideBar()"
  nzWrapClassName="wrkPrfleDrawer"
>
  <ng-container *nzDrawerContent>
    <!-- <div *ngIf="appCond==1"> -->
    <app-wrok-profile [wrkData]="wrksdata"></app-wrok-profile>
    <!-- </div> -->
  </ng-container>
</nz-drawer>
